import styled from 'styled-components';
import {
    LARGE_TEXT_PX,
    SMALL_TEXT_PX,
    BASE_TEXT_PX,
    DARK_GRAY_FONT_COLOR,
    ORANGE_FONT_COLOR,
    WHITE_FONT_COLOR,
    TITLE_FONT_COLOR,
    FONT_FAMILY_DEMI,
    FONT_FAMILY_REGULAR,
    CURSOR,
    DARK_RED_FONT_COLOR
} from 'src/styles/fonts/MCFontConstants';
import media from '../../../styles/Media.styled';

export const GridContainer = styled.div`
    box-shadow: ${({ boxShadow }) => (boxShadow ? boxShadow : '0px 3px 6px rgba(0,0,0,0.16)')};
    border-radius: 6px;
    background: ${WHITE_FONT_COLOR};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '8px')};
    margin-bottom: 10px;
    ${media.mobileDevice`
        margin-left: ${({ isCondensedView, isFromReportUsage }) => (isCondensedView && !isFromReportUsage ? '8px' : '0')};
        margin-right: ${({ isCondensedView, isFromReportUsage }) => (isCondensedView && !isFromReportUsage ? '8px' : '0')};
        margin-top: ${({ isCondensedView, isFromSurgeryBomChanges, isFromSurgery, countryISOCode, isFromConsignmentBilling }) => 
            (isCondensedView && (isFromSurgery || isFromConsignmentBilling)) 
                ? countryISOCode ? '55px' : "40px"
                : (!isCondensedView && isFromSurgery) 
                    ? '10px' 
                    : (isFromSurgeryBomChanges) 
                        ? '10px' 
                        : '10px'};
    `}
`;

export const IconGridItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ background }) => background};
    padding: 0 10px;
    border-radius: 6px 0px 0px 6px;
    min-height: 100%;
    width:  ${({ width }) => width? width: ''};
`;

export const ContentGridItem = styled.div`
    display: flex;
    align-items: ${({ status }) => ((status === 'bomChange' || status === 'reportIssue')  ? 'flex-start' : 'center')};
    flex-direction: ${({ status }) => ((status === 'bomChange' || status === 'reportIssue') ? 'column' : 'row')};
    padding: 10px 5px;
`;

export const HeaderMessage = styled.div`
    font-size: ${({ headerFontSize }) => headerFontSize? headerFontSize:LARGE_TEXT_PX};
    color: ${({ isFromReportUsage, status }) => (status === 'error' ? DARK_RED_FONT_COLOR : isFromReportUsage ? ORANGE_FONT_COLOR : DARK_GRAY_FONT_COLOR)};
    font-family: ${FONT_FAMILY_DEMI};
    text-align: ${({ textAlign }) => textAlign};
    white-space: ${({ whiteSpace }) => whiteSpace};
    padding: 0 10px;
`;

export const BelowMessage = styled.div`
    font-size: ${({ messageFontSize }) => messageFontSize? messageFontSize: SMALL_TEXT_PX};
    color: ${DARK_GRAY_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    text-align: ${({ textAlign }) => textAlign};
    padding: 0 10px;

    ${media.mobileDevice`
        word-break: break-word;
    `}
`;

export const FlexContainer = styled.div`
    display: flex;
    flex-direction: ${({ isFromConsignmentBilling, isFromReceiveSet }) => (isFromConsignmentBilling || isFromReceiveSet ? 'column' : 'row')};;
    align-items: ${({ isFromConsignmentBilling, isFromReceiveSet }) => (isFromConsignmentBilling || isFromReceiveSet ? 'flex-start' : 'center')};
    flex-wrap: wrap;
    
    ${media.mobileDevice`
        flex-direction: column;
        align-items: flex-start;
    `}
`;

export const MainMessage = styled.div`
    font-size: ${LARGE_TEXT_PX};
    color: ${DARK_GRAY_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    text-align: ${({ textAlign }) => textAlign};
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    padding: 0 10px;
    flex: 1;
    min-width: 0;
    
    ${media.mobileDevice`
        font-size: ${BASE_TEXT_PX};
        flex: none;
        width: 100%;
    `}
`;

export const SeparatorSpan = styled.span`
    padding: 0 10px;
    color: ${DARK_GRAY_FONT_COLOR};
`;

export const SurgeryNumberSpan = styled.span`
    font-size: ${SMALL_TEXT_PX};
    color: ${({ color }) => color || TITLE_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    cursor: ${({ cursor }) => cursor || CURSOR};
    padding: 0 10px;
`;